var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-EN"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EN",
    clipPath: "url(#clip-EN)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "united-kingdom_3_",
    "data-name": "united-kingdom (3)",
    transform: "translate(0 -85.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1549",
    "data-name": "Rectangle 1549",
    width: 47.999,
    height: 32,
    transform: "translate(0 85.33)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M27,85.33H21v13H0v6H21v13h6v-13H48v-6H27Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(29.217 106.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M393.785,315.358l11.082,6.157v-6.157Z",
    transform: "translate(-386.085 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M311.652,315.358l18.782,10.435v-2.951l-13.471-7.484Z",
    transform: "translate(-311.652 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M325.431,352.654,311.652,345v7.656Z",
    transform: "translate(-311.652 -342.219)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M311.652,315.358l18.782,10.435v-2.951l-13.471-7.484Z",
    transform: "translate(-282.435 -208.463)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M311.652,315.358l18.782,10.435v-2.951l-13.471-7.484Z",
    transform: "translate(-282.435 -208.463)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0 106.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M8.469,315.356,0,320.061v-4.705Z",
    transform: "translate(0 -315.356)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M41.884,329.51v9.108H25.491Z",
    transform: "translate(-23.101 -328.183)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M13.471,315.358,0,322.842v2.951H0l18.782-10.435Z",
    transform: "translate(0 -208.463)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(0 85.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M11.082,137.115,0,130.958v6.157Z",
    transform: "translate(0 -126.68)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M18.782,95.765,0,85.33v2.951l13.471,7.484Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M53.366,85.33l13.779,7.656V85.33Z",
    transform: "translate(-48.363 -85.33)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M18.782,95.765,0,85.33v2.951l13.471,7.484Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M18.782,95.765,0,85.33v2.951l13.471,7.484Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(29.217 85.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M421.659,151.151l8.469-4.705v4.705Z",
    transform: "translate(-411.346 -140.717)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M311.652,94.439V85.331h16.393Z",
    transform: "translate(-311.652 -85.331)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M316.963,95.765l13.471-7.484V85.33h0L311.652,95.765Z",
    transform: "translate(-282.435)",
    fill: "#d80027"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b5822947.svg";
export { ForwardRef as ReactComponent };